
/**
 * --- External Imports ---
 */
import { Box, Grid, Radio } from "@mui/material";
import { Field, Input } from "@ngt/forms-core";
import { FC } from "react";

/**
 * --- Internal Imports ---
 */
import { RadioGroupFormField } from "../../../../api/dtos/dtos";
import InputRadioGroupField from "../InputRadioGroupField";
import RadioControlLabel from "../labels/RadioControlLabel";
import { IFormFieldComponentProps } from "../types/FieldTypes";
import FieldErrors from "../utils/FieldErrors";
import FormFieldChildComponent from "./FormFieldChildComponent";
import RadioGroupControlLabel from "../labels/RadioGroupControlLabel";

/**
 * --- Radio Group Export ---
 */
const FormFieldRadioGroup: FC<IFormFieldComponentProps<RadioGroupFormField>> = ({
    field, 
    form
}) => {
    return (
        <RadioGroupControlLabel 
            field={field}
            control={
                <Field propertyPath={`${form.name}.${field.name}`}>
                    <Input 
                        component={InputRadioGroupField} 
                        sx={{ display: 'flex', alignSelf: 'start' }} 
                        fullWidth
                        defaultValue={field.defaultValue?.toString() ?? undefined}
                    >
                        <Grid container>
                            {
                                field.radios?.map(x => (
                                    <Grid item xs={x.rowRatio ?? 12} key={`${x.id}-${x.name}-${x.order}`}>
                                        <RadioControlLabel
                                            field={x}
                                            control={
                                                <Radio
                                                    key={`${x.name}-${x.value}`}
                                                    value={x.value?.toString()}
                                                />
                                            }
                                        />
                                        {
                                            <Box ml='34px'>
                                                {
                                                    x.children?.map((child) => {
                                                        return (
                                                            <FormFieldChildComponent key={`${form.name}-${child.id}-${child.name}`} child={child} form={form} />
                                                        )
                                                    })
                                                }
                                            </Box>
                                        }
                                    </Grid>
                                ))
                            }
                        </Grid>
                        <FieldErrors />
                    </Input>
                </Field>
            }
        />
    );
}

export default FormFieldRadioGroup;